import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { settingsApi } from '../api/settingsApi';

export function useCalendarInsightsViews() {
  return useQuery({
    queryKey: keys.settings.calInsights(),
    queryFn: ({ signal }) => settingsApi.getCalInsightsViews({ signal }),
    staleTime: 300_000,
  });
}

export function useCalendarInsightsView(view: string) {
  return useQuery({
    queryKey: keys.settings.calInsights(view),
    queryFn: ({ signal }) => settingsApi.getCalInsightsView(view, { signal }),
    enabled: !!view,
    staleTime: 300_000,
  });
}

export function useUpdateCalendarInsightsView(view: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: unknown) => settingsApi.updateCalInsightsView(view, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: keys.settings.calInsights(view) });
    },
  });
}
